import { combineReducers } from 'redux';

import { createResourceModuleReducerMap } from 'medialoopster/rest';

import { FileRootState } from './types';

export default combineReducers<FileRootState>(createResourceModuleReducerMap('file', 'files'));
